// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".images_67\\+fT{display:flex;flex-wrap:wrap;gap:1.2rem}.item_HAXlX{border-radius:4px;cursor:pointer;height:8rem;overflow:hidden;width:8rem}@media only screen and (min-width:1264px){.item_HAXlX.isProductPage_f7-PL{height:9.4rem;width:11.2rem}}.image_KxQrH{height:100%;width:100%}.image_KxQrH img,.image_KxQrH picture{display:block;height:100%;-o-object-fit:cover;object-fit:cover;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"images": "images_67+fT",
	"item": "item_HAXlX",
	"isProductPage": "isProductPage_f7-PL",
	"image": "image_KxQrH"
};
module.exports = ___CSS_LOADER_EXPORT___;
